import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const HealthAndWellbeingPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  wellbeingOfficerContact,
  hrContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Health_and_Wellbeing_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Health and Wellbeing Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to fostering a positive workplace environment that promotes the physical, mental, and emotional wellbeing of all employees.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, and temporary workers across all locations and operations.
      </p>

      <h4 className="section-title">3. Our Commitment</h4>
      <ul>
        <li>Providing access to resources and support to enhance health and wellbeing.</li>
        <li>Encouraging open communication about wellbeing issues without stigma or discrimination.</li>
        <li>Implementing initiatives that promote work-life balance, stress reduction, and healthy lifestyles.</li>
        <li>Supporting employees in managing health conditions and returning to work after illness.</li>
      </ul>

      <h4 className="section-title">4. Mental Health and Stress Management</h4>
      <p className="section-content">
        {clientName || "The Company"} recognises the impact of mental health on overall wellbeing and productivity. We will:
      </p>
      <ul>
        <li>Provide training for managers to recognise and support mental health concerns.</li>
        <li>Offer confidential counselling services and Employee Assistance Programmes (EAP).</li>
        <li>Promote stress awareness and provide tools for managing workplace pressures.</li>
      </ul>

      <h4 className="section-title">5. Physical Health and Safety</h4>
      <p className="section-content">
        We ensure a safe physical working environment and encourage healthy habits including:
      </p>
      <ul>
        <li>Ergonomic assessments of workstations and vehicles.</li>
        <li>Encouraging regular breaks and physical activity.</li>
        <li>Providing health screenings and vaccinations where appropriate.</li>
      </ul>

      <h4 className="section-title">6. Work-Life Balance</h4>
      <p className="section-content">
        Flexible working arrangements and leave policies will be promoted to help employees balance personal and professional commitments.
      </p>

      <h4 className="section-title">7. Support for Employees</h4>
      <p className="section-content">
        Support includes:
      </p>
      <ul>
        <li>Access to wellbeing resources and workshops.</li>
        <li>Confidential advice and support lines.</li>
        <li>Reasonable adjustments for health-related needs.</li>
      </ul>

      <h4 className="section-title">8. Roles and Responsibilities</h4>
      <p className="section-content"><strong>Managers:</strong> Foster supportive teams and identify employees needing help.</p>
      <p className="section-content"><strong>Employees:</strong> Take responsibility for their own wellbeing and seek help as needed.</p>
      <p className="section-content"><strong>HR and Wellbeing Officer:</strong> Develop and deliver wellbeing initiatives and support services. Contact: {wellbeingOfficerContact || "[Insert Contact]"}</p>

      <h4 className="section-title">9. Monitoring and Review</h4>
      <p className="section-content">
        The effectiveness of this policy will be monitored regularly, with feedback encouraged from employees, and reviewed annually or as required.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I acknowledge that I have read, understood, and will support the Health and Wellbeing Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default HealthAndWellbeingPolicy;
